import classNames from 'classnames';
import { ButtonHTMLAttributes } from 'react';

import './Button.scss';

const handleOnClick = (disabled: boolean, cb?: React.DOMAttributes<HTMLButtonElement>['onClick']) => {
  return (event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
    if (
      // Chrome version < 116 does not handle disabled attribute for bubbling
      event.currentTarget.disabled ||
      // handle when in devTools user removes attribute "disabled"
      disabled
    ) {
      event.preventDefault();
      return;
    }
    cb && cb(event);
  };
};

type ButtonProps = Readonly<
  ButtonHTMLAttributes<HTMLButtonElement> &
    React.RefAttributes<HTMLButtonElement> &
    React.PropsWithChildren & {
      className?: string;
      outline?: boolean;
      withIcon?: boolean;
      withoutBorder?: boolean;
      size?: 'sm' | 'md' | 'lg' | 'fit';
      bgColor?: 'blue' | 'error' | 'accent';
      isFormButton?: boolean;
      position?: 'left-side' | 'centered' | 'right-side';
    }
>;

export const Button: React.FC<ButtonProps> = ({
  onClick,
  className,
  type = 'button',
  outline = false,
  withIcon = false,
  withoutBorder = false,
  size = 'lg',
  bgColor = 'blue',
  children,
  disabled = false,
  isFormButton = false,
  position,
  ...rest
}) => {
  return (
    <button
      onClick={handleOnClick(disabled, onClick)}
      className={classNames(
        'custom-btn',
        {
          'custom-btn__outline': outline,
          [`custom-btn__${size}`]: size,
          [`custom-btn__${bgColor}`]: bgColor,
          [`custom-btn__without-border`]: withoutBorder,
          'custom-btn__with-icon': withIcon,
          'custom-btn__form-button': isFormButton,
          [`custom-btn__form-button--${position}`]: isFormButton && position,
        },
        className,
      )}
      type={type}
      disabled={disabled}
      {...rest}
    >
      {children}
    </button>
  );
};
